import Challenge from '../../model/Challenge'
import styles from './ChallengeMark.module.css'

export default function ChallengeMark({
  challenge,
  className,
}: {
  challenge: Challenge
  className?: string
}) {
  const slotClass = [styles.slot, className].filter(Boolean).join(' ')

  if (challenge.markUrl) {
    return (
      <span className={slotClass}>
        <img src={challenge.markUrl} alt="" className={styles.image} />
      </span>
    )
  }

  const initial = (challenge.name?.trim().charAt(0) || '?').toUpperCase()
  return (
    <span
      className={[slotClass, styles.fallback].join(' ')}
      style={{ background: challenge.primaryColor || 'var(--blue)' }}
    >
      {initial}
    </span>
  )
}
